import { render } from "./W3GetCoordinates.vue?vue&type=template&id=7a8d852a&ts=true"
import script from "./W3GetCoordinates.vue?vue&type=script&lang=ts"
export * from "./W3GetCoordinates.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__